import produce from 'immer';
import I18n from 'I18n';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { EMAIL_TYPE } from 'messaging-types-lib/content/contentEmail';
import { CANCEL_SCHEDULED_EMAIL_ERROR, FETCH_CONTENT_SCHEMA_SUCCEEDED, UPDATE_PUBLISH_IMMEDIATELY, UPDATE_EMAIL_TYPE } from 'ContentEditorUI/redux/actions/actionTypes';
import { withBasePublishAsJSObject } from 'ContentEditorUI/redux/reducers/contentModel/publish/withBasePublish';
import StateStatusGroups from 'ContentUtils/constants/StateStatusGroups';
// @ts-expect-error Untyped module
import { EMAIL_TYPE_FOR_MODEL } from 'EmailEditorUI/lib/EmailTypeConstants';
import { ContentStates } from 'ContentComponents/constants/ContentStates';
const emailPublishReducer = (state = {}, action) => {
  return produce(state, draft => {
    switch (action.type) {
      case FETCH_CONTENT_SCHEMA_SUCCEEDED:
        {
          const {
            content = {
              publishImmediately: true,
              state: ContentStates.DRAFT
            }
          } = action.response;
          const {
            publishImmediately
          } = content;
          draft.publishImmediately = Boolean(publishImmediately && content.state !== EMAIL_TYPE.LOCALTIME_EMAIL);
          return draft;
        }
      case UPDATE_PUBLISH_IMMEDIATELY:
        {
          if (draft.emailType === EMAIL_TYPE.LOCALTIME_EMAIL) {
            draft.emailType = EMAIL_TYPE.BATCH_EMAIL;
            draft.subcategory = 'batch';
          }
          return draft;
        }
      case UPDATE_EMAIL_TYPE:
        {
          const {
            payload
          } = action;
          if (draft.state && StateStatusGroups.PUBLISHED.includes(draft.state)) {
            draft = Object.assign({}, draft, EMAIL_TYPE_FOR_MODEL.PUBLISHED[payload.emailType]);
            return draft;
          }
          const mergedProperties = EMAIL_TYPE_FOR_MODEL.UNPUBLISHED[payload.emailType];
          if (payload.emailType === EMAIL_TYPE.LOCALTIME_EMAIL) {
            mergedProperties.publishImmediately = false;
          } else if (payload.publishImmediately) {
            mergedProperties.publishImmediately = true;
          }
          draft = Object.assign({}, draft, mergedProperties);
          return draft;
        }
      case CANCEL_SCHEDULED_EMAIL_ERROR:
        FloatingAlertStore.addAlert({
          id: 'sendCancelled',
          message: I18n.text(`panes.review.sections.content.items.send_cancelled.message_error`),
          sticky: true,
          type: 'danger'
        });
        return draft;
      default:
        {
          return draft;
        }
    }
  });
};
export default withBasePublishAsJSObject(emailPublishReducer);